import Aside from "../Component/Aside";
import Footer from "../Component/Footer";
import Form from "../Component/Form";
import Header from "../Component/Header";

export default function FormExample() {
    return <>
        <Header />
        <Aside />
        <Form />
        <Footer />
    </>
}